import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { createWarning } from '@core/helpers/create-validator.helper';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';

@Injectable()
export class DatiIdentificativiWarningsService {
    constructor(private readonly store: Store<Revisione53State>) {}

    my_ObbligoRilevazioneSedeRecapito = createWarning(this.store, (myVerbale) => {
        const my_ObbligoRilevazioneSedeRecapito = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_ObbligoRilevazioneSedeRecapito;
        const my_CapSedeRecapito = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_CapSedeRecapito;

        if (my_ObbligoRilevazioneSedeRecapito != 'N' || isNilOrEmpty(my_CapSedeRecapito)) {
            return 'Se la cooperativa non ha una sede di recapito riportare la sede legale';
        } else {
            return null;
        }
    });

    my_CkScadenzaSocieta = createWarning(this.store, (myVerbale) => {
        const my_CkScadenzaSocieta = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_CkScadenzaSocieta;

        if (my_CkScadenzaSocieta === '1') {
            return 'Termine della società : Verificare la condizione statutaria del recesso soci';
        }
    });

    //Serve???
    my_Anno1 = createWarning(this.store, (myVerbale) => {
        if (myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_Anno2 >= '3000') {
            return 'È sconsigliato inserire una data del quarto millennio';
        }
    });

    my_Test1 = createWarning(this.store, (myVerbale) => {
        if (myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_Test1 === '3') {
            return 'È sconsigliato';
        }
    });

    my_DataTermine = createWarning(this.store, (myVerbale) => {
        const my_DataTermine = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_DataTermine;
        const dateDataTermineTrash = new Date(my_DataTermine);
        const dateDataTermine = new Date(dateDataTermineTrash.getFullYear() + '/' + dateDataTermineTrash.getMonth() + '/' + dateDataTermineTrash.getDate());
        const dateToday = new Date(new Date().getFullYear() + '/' + new Date().getMonth() + '/' + new Date().getDate());

        if (!isNilOrEmpty(my_DataTermine) && dateToday.getTime() >= dateDataTermine.getTime() + 1) {
            return 'La data termine della società è trascorsa. Occorre irrogare la diffida.';
        }
    });

    my_CkMutualPrev = createWarning(this.store, (myVerbale) => {
        const CkMutualPrev = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_CkMutualPrev;
        if (CkMutualPrev === '3') {
            return 'La cooperativa non è iscritta all Albo. Occorre irrogare la diffida';
        }
    });

    my_TipoSezEnte = createWarning(this.store, (myVerbale) => {
        const tipoSezEnte = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_TipoSezEnte;
        const my_CkPeriodicRevi = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_CkPeriodicRevi;
        if (tipoSezEnte === '2' && my_CkPeriodicRevi === '2') {
            return 'Le cooperative sociali sono revisionate annualmente.';
        }
    });
}
